export function addLeadingZeros(num: number, totalLength: number) {
  if (num >= 10) return String(num);
  return String(num).padStart(totalLength, '0');
}
